<template>
  <v-container
    :class="{
      error: paxError(field),
      add_pass_field: true
    }"
    xs4
  >
    <v-layout column>
      <div class="head">{{ type }}</div>
      <div class="subhead">{{ desc }}</div>
      <v-select
        :items="passengerValueRange(min, max)"
        @change="validatePax(field, min, max)"
        v-model="thisField"
        outlined
        dense
      ></v-select>
    </v-layout>
  </v-container>
</template>

<script>
import store from "../../../store";
import Shared from "@/mixins/Shared";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

export default {
  name: "PassengerSelectField",
  data() {
    return {
      timeout: null,
      timer: false
    };
  },
  props: {
    type: String,
    desc: String,
    field: String,
    icon: String,
    min: Number,
    max: Number
  },
  store: store,
  computed: {
    ...mapFields([
      "active",
      "mobileDevice",
      "form",
      "form_fields",
      "form_fields.pax_a",
      "form_fields.pax_c",
      "form_fields.pax_i",
      "form_fields.pax_a_r",
      "form_fields.pax_c_r",
      "form_fields.pax_i_r",
      "samepassengers"
    ]),
    thisPax() {
      return this[this.field];
    },
    setTickLabels() {
      let l = [];
      for (let x = this.min; x <= this.max; x++) {
        l.push(x);
      }
      return l;
    },
    getMin() {
      return this.min;
    },
    getMax() {
      return this.max;
    },
    thisField: {
      get() {
        return this.form_fields[this.field];
      },
      set(val) {
        this.$store.commit("addPax", [this.field, val]);
      }
    },
    get_accompanied(val) {
      return val <=
        Number(this.form_fields.pax_a) + Number(this.form_fields.pax_c)
        ? true
        : false;
    }
  },
  watch: {
    thisPax() {
      const index = this.getFormIndexByPath(this.$route.path);
      if (
        index === 1 &&
        this.validatePassengersReturn() === true
      ) {
        this.setNextStepQuery(index);
      } else if (
        index === 0 &&
        this.validatePassengers() === true
      ) {
        this.setNextStepQuery(index);
      }
    }
  },
  mixins: [Shared],
  methods: {
    passengerValueRange(min, max) {
      let p = [];
      for (let x = min; x <= max; x++) {
        p.push(x);
      }
      return p;
    },
    paxError(field) {
      if (field == "pax_i") {
        if (this.form_fields.pax_i > this.form_fields.pax_a) {
          return true;
        }
      } else if (field == "pax_i_r") {
        if (this.form_fields.pax_i_r > this.form_fields.pax_a_r) {
          return true;
        }
      }
      return false;
    },
    validatePax(field, min, max) {
      let f = this.form_fields[field];
      if (f < min) {
        f = min;
      } else if (f > max) {
        f = max;
      }
    },
    paxCount(field) {
      return Number(this.form_fields[field]);
    },
    testMin(count, min) {
      return count > min;
    },
    decrement(which) {
      if (which > this.min) {
        this.thisField = which - 1;
      }
    },
    increment(which) {
      if (which === undefined || which === null) which = 0;
      if (which < this.max) {
        this.thisField = which * 1 + 1;
      }
    }
  }
};
</script>
